import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import React, { memo } from 'react'
import { Box, Grid } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { TextField } from '@e3dc-react/shell/Elements/InputFields'
import { CompanyContactData } from '../../user/models'
import { useCountryOptions } from '@e3dc-react/shell/Hooks/useCountryOptions'
import SeparatorLine from 'src/Elements/Separator/SeparatorLine'

const useStyles = makeStyles()(theme => ({
  readOnlyDataField: {
    '& .MuiOutlinedInput-root.Mui-disabled': {
      backgroundColor: 'transparent !important',
      WebkitTextFillColor: 'black',
      border: 'none',
      '& .MuiOutlinedInput-notchedOutline': {
        border: 'none',
      },
      '& .MuiOutlinedInput-input.Mui-disabled': {
        WebkitTextFillColor: 'black',
      },
    },
  },
}))

type CompanyContactDataProps = {
  sapCustomerId: number
  ustId: string
  companyLocation: CompanyContactData
}

type ReadOnlyTextFieldProps = {
  label: string
  value?: string
  name?: string
}

const ReadOnlyTextField: React.FC<ReadOnlyTextFieldProps> = memo(({ label, value, name }) => {
  const { classes } = useStyles()
  return <TextField className={classes.readOnlyDataField} name={name} label={label} value={value || ''} disabled fullWidth />
})
ReadOnlyTextField.displayName = 'ReadOnlyTextField'

const CompanyContactDataView: React.FC<CompanyContactDataProps> = ({ sapCustomerId, ustId, companyLocation }) => {
  const { t } = useCustomTranslation()
  const { allCountries } = useCountryOptions()
  const country = allCountries.find(({ value }) => value === companyLocation?.Land)?.label
  const fields = [
    { label: t('common.address'), name: 'address', value: companyLocation?.PlaceOR },
    { label: t('common.city'), name: 'city', value: companyLocation?.Address },
    { label: t('common.zip'), name: 'zipCode', value: companyLocation?.PLZ },
    { label: t('common.phone'), name: 'phone', value: companyLocation?.Telefon },
    { label: t('common.country'), name: 'country', value: country },
    { label: t('common.email'), name: 'email', value: companyLocation?.Email },
    { label: t('common.fax'), name: 'fax', value: companyLocation?.Telefax },
    { label: t('common.sapCustomerId'), name: 'sapCustomerId', value: sapCustomerId > 0 ? sapCustomerId.toString() : '' },
    { label: t('common.ustId'), name: 'ustID', value: ustId },
  ]

  return (
    <Box marginTop={2} sx={{ width: '100%' }}>
      <Grid container spacing={2}>
        {fields.map((field, index) => (
          <Grid item xs={12} sm={6} key={index}>
            <ReadOnlyTextField label={field.label} value={field.value} name={field.name} />
          </Grid>
        ))}
      </Grid>
      <SeparatorLine />
    </Box>
  )
}

export default CompanyContactDataView
